if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");

        this.sectionId = (this.form.id || "").replace("product-form-", "");
        this.variantInput = this.form.querySelector('input[name="id"]');
        this.variantSwitcher = document.querySelector(`variant-radios[data-section="${this.sectionId}"], variant-selects[data-section="${this.sectionId}"]`);

        if (this.variantInput) {
          this.variantInput.addEventListener("change", () => this.syncPriceRequestState());
        }

        if (this.variantSwitcher) {
          this.variantSwitcher.addEventListener("change", () => {
            window.setTimeout(() => this.syncPriceRequestState(), 0);
          });
        }

        const priceNode = document.getElementById(`price-${this.sectionId}`);
        if (priceNode) {
          this.priceObserver = new MutationObserver(() => this.syncPriceRequestState());
          this.priceObserver.observe(priceNode, { childList: true, subtree: true, characterData: true });
        }

        window.requestAnimationFrame(() => this.syncPriceRequestState());
      }

      isPriceRequestProduct() {
        const section = this.closest(".shopify-section") || document;
        const title = section.querySelector(".product__title")?.textContent?.trim() || "";
        return title.includes("Calacatta Viola") || title.includes("Fior di Bosco");
      }

      getVariantData() {
        if (!this.variantSwitcher) return [];
        const json = this.variantSwitcher.querySelector('script[type="application/json"]');
        if (!json) return [];

        try {
          return JSON.parse(json.textContent);
        } catch (error) {
          console.error("Could not read variant data", error);
          return [];
        }
      }

      getSelectedVariant() {
        const variantId = String(this.variantInput?.value || "");
        return this.getVariantData().find((variant) => String(variant.id) === variantId);
      }

      isPriceRequestVariant() {
        if (!this.isPriceRequestProduct()) return false;
        const variant = this.getSelectedVariant();
        return Boolean(variant && Number(variant.price) === 0);
      }

      getRequestLink() {
        let link = this.querySelector(".mm-price-request-button");
        if (link) return link;

        link = document.createElement("a");
        link.className = "button is-main mm-price-request-button";
        link.href = "/pages/contact";
        link.textContent = "Request price";
        link.style.width = "100%";
        link.style.display = "none";
        link.setAttribute("aria-label", "Request price");

        const buttons = this.querySelector(".product-form__buttons");
        if (buttons) buttons.appendChild(link);
        return link;
      }

      syncPriceRequestState() {
        const addButton = this.querySelector('[name="add"]');
        if (!addButton) return;

        const requestLink = this.getRequestLink();
        const isRequest = this.isPriceRequestVariant();

        if (isRequest) {
          addButton.setAttribute("disabled", true);
          addButton.style.display = "none";
          requestLink.style.display = "inline-flex";
        } else {
          addButton.style.display = "";
          requestLink.style.display = "none";
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.isPriceRequestVariant()) {
          this.syncPriceRequestState();
          return;
        }

        const submitButton = this.querySelector('[type="submit"]');

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");

        const body = JSON.stringify({
          ...JSON.parse(serializeForm(this.form)),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
          .then((response) => response.json())
          .then((parsedState) => {
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            this.syncPriceRequestState();
          });
      }
    }
  );
}
